<div class="informacoes-container">
  @if (isLoading) {
    <div class="loading-container">
      <mat-spinner diameter="40"></mat-spinner>
      <p>
        {{ "COMPONENTS.INFORMACOES_OPERACAO.loading" | transloco }}
      </p>
    </div>
  } @else if (informacoesOperacao) {

    <div class="header mt-2">
      <div class="ordem-servico">
        <h3 class="mb-3">
          {{ "COMPONENTS.INFORMACOES_OPERACAO.service_order" | transloco }}
        </h3>

        <h2>{{ informacoesOperacao.vc_service_id }}</h2>
      </div>

      <div class="status mt-2">
        <div class="status-principal">
          <div
            class="status-dot"
            [class]="informacoesOperacao.en_estado">
          </div>

          <div class="status-info ms-2">
            <span class="status-text mb-1">
              {{ formatarEstado(informacoesOperacao.en_estado) }}
            </span>

            <span class="ultima-mensagem">
              {{
                "COMPONENTS.INFORMACOES_OPERACAO.last_message"
                  | transloco:{
                      date: formatarData(informacoesOperacao.ultima_mensagem?.data),
                      time: formatarHora(informacoesOperacao.ultima_mensagem?.hora)
                    }
              }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="divisor"></div>

    <div class="metricas-grid">

      <div class="metrica-card">
        <div class="icon-container">
          <img
            src="assets/produtividade/icone-produtividade.svg"
            alt="{{ 'COMPONENTS.INFORMACOES_OPERACAO.productivity' | transloco }}"
          />
        </div>

        <div class="metrica-info">
          <div class="metrica-header">
            <h4>{{ informacoesOperacao.produtividade }} HA</h4>

            @if (informacoesOperacao.variacao_produtividade) {
              <span
                class="variacao"
                [class.positiva]="informacoesOperacao.variacao_produtividade > 0"
                [class.negativa]="informacoesOperacao.variacao_produtividade < 0"
              >
                <span class="icone-variacao">
                  @if (informacoesOperacao.variacao_produtividade > 0) {
                    <img
                      src="assets/produtividade/icone-variacao-positiva.svg"
                      alt="Positive variation"
                    />
                  } @else {
                    <img
                      src="assets/produtividade/icone-variacao-negativa.svg"
                      alt="Negative variation"
                    />
                  }
                </span>
                {{ informacoesOperacao.variacao_produtividade }}%
              </span>
            }
          </div>

          <p>
            {{ "COMPONENTS.INFORMACOES_OPERACAO.productivity" | transloco }}
          </p>
        </div>
      </div>

      <div class="metrica-card">
        <div class="icon-container">
          <img
            src="assets/produtividade/icone-eficiencia.svg"
            alt="{{ 'COMPONENTS.INFORMACOES_OPERACAO.efficiency' | transloco }}"
          />
        </div>

        <div class="metrica-info">
          <h4>{{ informacoesOperacao.eficiencia }}%</h4>
          <p>
            {{ "COMPONENTS.INFORMACOES_OPERACAO.efficiency" | transloco }}
          </p>
        </div>
      </div>

      <div class="metrica-card">
        <div class="icon-container">
          <img
            src="assets/produtividade/icone-produtividade-tempo.svg"
            alt="{{ 'COMPONENTS.INFORMACOES_OPERACAO.productivity_per_time' | transloco }}"
          />
        </div>

        <div class="metrica-info">
          <h4>
            {{ informacoesOperacao.produtividade_por_tempo }} HA/min
          </h4>
          <p>
            {{ "COMPONENTS.INFORMACOES_OPERACAO.productivity_per_time" | transloco }}
          </p>
        </div>
      </div>

      <div class="metrica-card">
        <div class="icon-container">
          <img
            src="assets/produtividade/icone-tempo-produtivo.svg"
            alt="{{ 'COMPONENTS.INFORMACOES_OPERACAO.productive_time' | transloco }}"
          />
        </div>

        <div class="metrica-info">
          <h4>
            {{ informacoesOperacao.tempo_produtivo }}h/
            {{ informacoesOperacao.tempo_total_trabalhado }}h
          </h4>
          <p>
            {{ "COMPONENTS.INFORMACOES_OPERACAO.productive_time" | transloco }}
          </p>
        </div>
      </div>

    </div>

    <app-ofensores-produtividade
      [ofensoresProdutividade]="ofensoresProdutividade">
    </app-ofensores-produtividade>

  } @else {
    <div class="no-data">
      <p>
        {{ "COMPONENTS.INFORMACOES_OPERACAO.no_data" | transloco }}
      </p>
    </div>
  }
</div>
